'use strict';

// init a global object (this can be used for sharing things like variables, plugins, and functions between components)
window.basecoat = window.basecoat || {};

basecoat.init = {};
basecoat.postInit = {};

+function ($) {

  $.fn.basecoat = function (component) {
    // console.log('initializing basecoat');
    if (typeof component === 'string') {
      return this.each(function () {
        if (basecoat.init[component]) basecoat.init[component].call(this);
        if (basecoat.postInit[component]) basecoat.postInit[component].call(this);
        // console.log('init:', component);
      });
    }
    return this.each(function () {
      for (component in basecoat.init) {
        if (basecoat.init[component]) basecoat.init[component].call(this);
        // console.log('init:', component);
      }
      for (component in basecoat.postInit) {
        if (basecoat.postInit[component]) basecoat.postInit[component].call(this);
        // console.log('init:', component);
      }
    });
  };

  // add a class to html tag if the device is mobile (can be useful elsewhere in css and js)
  basecoat.isMobile = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(navigator.userAgent);
  basecoat.isDesktop = !basecoat.isMobile;
  $('html').toggleClass('is-mobile', basecoat.isMobile);
  $('html').toggleClass('is-desktop', basecoat.isDesktop);

  // initialize all of basecoat's JS components when jQuery's DOM ready event is fired
  $(function () {
    // NOTE: components may need to be manually initialized when added to the DOM later by AJAX or other JS frameworks
    // basecoat can be manually initialized in a specific area like this: $('.new-stuff').basecoat();
    $(document).basecoat();
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/app.js
// module id = 2
// module chunks = 0